import React from 'react';

interface IPostCardLayoutDefaultParams {
  children: React.ReactNode;
}

/**
 * Шаблон страницы поста
 */
export const PostCardLayoutWithSidebar = ({ children }: IPostCardLayoutDefaultParams) => <div>{children}</div>;
